import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import * as Yup from "yup";
import {
    COMPANY_FETCH_URL,
    ESTATE_FETCH_URL,
    REGION_FETCH_URL,
    WORKER_TYPES_URL,
    ZONE_FETCH_URL,
  } from "../../../configs/constants";


import Table from "components/Table";
import Filter from "@Components/Filter";

let model = [
  { id: "employee_id", label: "Employee ID", type: "string" },
  { id: "name", label: "Name", type: "string" },
  { id: "role", label: "Role", type: "string" },
  { id: "company", label: "Company", type: "objectname" , order: "name" },
  { id: "zone", label: "Zone", type: "objectname", order: "name" },
  { id: "region", label: "Region", type: "objectname", order: "name" },
  { id: "estate", label: "Estate", type: "objectname" , order: "name" },
 // { id: "created_by_name", label: "Created By", type: "string" },
 { id: "created_by", label: "Created By", type: "objectname",  order: "name" },
  { id: "created_at", label: "Created Date & Time", type: "datetime" },
  { id: "action_by", label: "Updated By", type: "string" },
  { id: "deleted_by", label: "Deleted By", type: "string" },
  { id: "deleted_at", label: "Deleted Date", type: "string" },
  { id: "last_login", label: "Last Login Date & Time", type: "datetime" },
];




// const filterInitialValues = {
//   date: null,
//   employee_id: "",
//   name: "",
//   company: "",
//   zone: "",
//   region: "",
//   estate: "",
// };

const WorkerUser = () => {
  const [filterValues, setFilterValues] = useState({});
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [selectedFormDate, setSelectedFormDate] = useState(null);
  const [selectedtoDate, setSelectedToDate] = useState(null);

  const details = useLocation();
  const URLS = {
    WORKER_LOG: "auditlog/user-management/?type=worker",
  };
  const today = new Date();
  const options = { timeZone: 'Asia/Kuala_Lumpur' };
  let date = today.toLocaleDateString('en-GB', options);
  date = date.split('/').reverse().join('-');

  const filterFields = [

    {
      type: "datepicker",
      label: "From Last Login Date",
      name: "from_last_login",
      maxDate: selectedtoDate,
      getValue: getFormDate,
      required: true

    },
    {
      type: "datepicker",
      label: "To Last Login Date",
      name: "to_last_login",
      minDate: selectedFormDate,
      getValue: getToDate,
      required: true

    },
    {
      type: "input",
      name: "employee_id",
      label: "Worker ID"
     },
  {
    type: "input",
    name: "name",
    label: "Worker Name"
},
    {
      type:"reactselect",
      name: "worker_type",
      label: "Worker Type",
      key: "worker_type",
      required: true,
      proxyUrl: WORKER_TYPES_URL,
      paginated: false,
    },

    
      {
        type: "reactselect",
        name: "company_id",
        label: "Company",
        proxyUrl: COMPANY_FETCH_URL,
        paginated: true,
        
  
      },
    
   
    
    
 
    
    
    
  ];
  const getFormDate = (e) => {
    setSelectedFormDate(e);
  };
  const getToDate = (e) => {
    setSelectedToDate(e);
  };

  const validationSchema = Yup.object({
    from_last_login: Yup.date().required("Date is required").nullable().typeError("Invalid From Last Login Date"),
    to_last_login: Yup.date().required("Date is required").nullable().typeError("Invalid To Last Login Date"),
    worker_type: Yup.string().required("Worker type is required").typeError("Worker type is required")
  });
  const filterInitialValues = {
    from_last_login: date,
    to_last_login: date,

  };
  let filters = {};
  if ("searchParams" in details) {
    if (details.searchParams.from_date.dateForAPI) {
      filters["from_last_login"] = details.searchParams.from_last_login.dateForAPI;
    }
    if (details.searchParams.to_date.dateForAPI) {
      filters["to_last_login"] = details.searchParams.to_last_login.dateForAPI;
    }

  }

  const onFilterRequest = (values) => {
    setFiltersApplied(true);

    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };
 


  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
        validationSchema={validationSchema}


      />
      {filtersApplied ? (

        <Table
          proxyURL={URLS.WORKER_LOG}
          model={model}
          exportUrl="url"
          excelExport={{ fileName: "WorkerUserAudit" }}

          filterValues={filterValues}
          noFilter
          noAddButton
        />
      ) : (
        <Table
          proxyURL={null}
          model={model}
          exportUrl="url"
          excelExport={{ fileName: "WorkerUserAudit" }}
          filterValues={filterValues}
          noFilter
          noAddButton
        />
      )}

    </>
  );
};
export default WorkerUser;

